<div class="details-wrapper">
  <div class="extension-detail-item">
    <h4>{{ mailbox?.extension?.extensionType.name | formatMailboxTypes }}</h4>
  </div>

  @if (mailbox?.extension?.number) {
    <h5>Extension Number</h5>
    <div class="detail-item">{{ mailbox.extension.number }}</div>
  }
</div>

<div class="details-wrapper">
  @if (mailbox?.extension?.name) {
    <h5>Extension Name</h5>
    <div class="detail-item">{{ mailbox.extension.name }}</div>
  }
</div>

@if (!isSmartVoicemail) {
  <div class="details-wrapper">
    @if (mailbox?.emailAddress) {
      <h5>Email</h5>

      @for (emailAddress of formattedEmailAddress; track emailAddress) {
        <div class="detail-item">
          <div class="break-word-detais-left-column">{{ emailAddress }}</div>
        </div>
      }
    }
  </div>

  <div class="details-wrapper">
    @if (mailbox) {
      <h5>Mark Messages as Read After Emailing</h5>
      <div class="detail-item">
        {{ mailbox.markReadAfterEmail.toString() | titlecase }}
      </div>
    }
  </div>

  <div class="details-wrapper">
    @if (mailbox) {
      <h5>Delete Incoming Messages Once Emailed</h5>
      <div class="detail-item">
        {{ mailbox.discardAudioAfterEmail.toString() | titlecase }}
      </div>
    }
  </div>

  <div class="details-wrapper">
    @if (mailbox) {
      <h5>Say Caller ID</h5>
      <div class="detail-item">
        {{ mailbox.sayCallerId.toString() | titlecase }}
      </div>
    }
  </div>

  <div class="details-wrapper">
    @if (mailbox) {
      <h5>Voicemail Pin</h5>

      <a
        color="primary"
        class="detail-item change-pin-button"
        mat-button
        (click)="onEditMailboxPinClick(mailbox)"
      >
        Change PIN
      </a>
    }
  </div>
}